export default __webpack_public_path__ + "static/media/ic-close-green.81e880fb.svg";